











import Vue from 'vue';
import { mapState } from 'vuex';
import AppToastArea from '@/components/AppToastArea.vue';
import AppTopbar from './components/AppTopbar.vue';
import AppNavbar from './components/AppNavbar.vue';
import '@lottiefiles/lottie-player';
import '@mdi/font/css/materialdesignicons.css';
import '@fortawesome/fontawesome-free/css/all.css';

export default Vue.extend({
  name: 'App' as string,

  components: {
    AppTopbar,
    AppNavbar,
    AppToastArea,
  },

  computed: {
    ...mapState([
      'user',
      'events',
    ]),
  },
  mounted(): void {
    this.$root.$i18n.locale = this.user.lang;
  },
});
